import { messages } from 'app/config/constants';
import { toast, ToastContent, ToastOptions } from 'react-toastify';
import getStore from 'app/config/store';
import { revalidateTabsThunk } from 'app/shared/reducers/validationerrors/validation-errors.reducer';
import React from 'react';
import { Row } from 'reactstrap';
import '../../app.scss';

export function showToast(toastType: (content: ToastContent, options?: ToastOptions | undefined) => React.ReactText, message: string) {
  const dispatch = getStore().dispatch;

  if ([messages.DATA_SAVED, messages.DATA_DELETED, messages.DATA_COPIED].includes(message)) {
    dispatch(revalidateTabsThunk());
  }
  if (!toast.isActive(window.btoa(encodeURIComponent(message)))) {
    if (toast.isActive(window.btoa(encodeURIComponent('Istekla sesija')))) {
      return;
    }
    const toastId = window.btoa(encodeURIComponent(message));
    toastType(message, {
      position: 'top-right',
      toastId,
      style: {
        width: '320px',
        marginLeft: 'auto',
      },
    });
  }
}

export function showActValidationErrorToast(errors: string[]) {
  const renderActErrorMessage = (messagePart: string) => {
    const acts = messagePart.split('ili');
    const mainAct = acts[0];

    return (
      <>
        <li>
          <strong>{`${mainAct} ${acts.length > 1 ? 'ili' : ''}`}</strong>
          <ul>
            {acts.slice(1).map((alternativeAct, index) => (
              <>
                <li>
                  <span>{`${alternativeAct} ${index !== acts.length - 2 ? 'ili' : ''}`}</span>
                </li>
              </>
            ))}
          </ul>
        </li>
      </>
    );
  };

  const content: ToastContent = (
    <div>
      <Row>
        <span>Nisu urudžbirani obavezni akti:</span>
      </Row>
      <Row>
        <ul className={'acts-error-line-break'}>{errors.map(messagePart => renderActErrorMessage(messagePart))}</ul>
      </Row>
    </div>
  );

  if (!toast.isActive(window.btoa(encodeURIComponent(errors[0])))) {
    if (toast.isActive(window.btoa(encodeURIComponent('Istekla sesija')))) {
      return;
    }
    const toastId = window.btoa(encodeURIComponent(errors[0]));
    toast.error(content, {
      position: 'top-right',
      toastId,
      style: {
        minWidth: '320px',
        marginLeft: 'auto',
      },
    });
  }
}

export function showMailMergeValidationErrors(errors: string[]) {
  const renderMailMergeErrorMessage = (messagePart: string) => {
    const parts = messagePart.split(' na kartici ');
    const fieldName = parts[0];
    const tabName = parts.length > 1 ? parts[1] : '';

    return (
      <li>
        <strong>{fieldName}</strong>
        {tabName && (
          <span>
            {' '}
            na kartici <strong>{tabName}</strong>
          </span>
        )}
      </li>
    );
  };

  const content: ToastContent = (
    <div>
      <Row>
        <span>Predmet ne sadrži obvezne podatke za izradu akta:</span>
      </Row>
      <Row>
        <ul className={'acts-error-line-break'}>{errors.map(messagePart => renderMailMergeErrorMessage(messagePart))}</ul>
      </Row>
    </div>
  );

  if (!toast.isActive(window.btoa(encodeURIComponent(errors[0])))) {
    if (toast.isActive(window.btoa(encodeURIComponent('Istekla sesija')))) {
      return;
    }
    const toastId = window.btoa(encodeURIComponent(errors[0]));
    toast.error(content, {
      position: 'top-right',
      toastId,
      style: {
        minWidth: '400px',
        marginLeft: 'auto',
      },
    });
  }
}
